import { render } from "./attachment_step.vue?vue&type=template&id=770faee0"
import script from "./attachment_step.vue?vue&type=script&lang=js"
export * from "./attachment_step.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__